import { FunctionComponent, useContext, useEffect, useRef, useState } from "react";
import styles from "./Invoice.module.css";
import {
  formatNumberWithCommas,
  invoiceDetailsProps,
  checking,
  soldTicketsRowType,
  splitLocation
} from "../../../helper";
import images from "../../../assets/images";
import { Button } from "@mui/material";
import { useLazyQuery, useMutation } from "@apollo/client";
import { AUTO_PAYOUT, INVOICE_DETAILS_DOWNLOAD } from "../../../features/Tickets/api/TicketsQuery";
import ToasterWithMessage from "../toaster";
import { globalContext } from "../../../Provider/AppProvider";
interface MarkAsSoldProps {
  row: soldTicketsRowType;
  handleCloseDialog: ()=> void;
  setCurrentPage : (value : number) => void
  openPopup ? : boolean;
  setColumnTypes: (value: string) => void;
  setSortType: (value: string) => void;
}

const InvoicePopup: FunctionComponent<MarkAsSoldProps> = ({
  row,
  handleCloseDialog,
  setCurrentPage,
  openPopup,
  setColumnTypes,
  setSortType
}) => {
  const { CloseIcon } = images;
  const [showInvoiceDetails, setShowInvoiceDetails] = useState<invoiceDetailsProps>()
  const contentRef = useRef(null);
  const {success,error}= ToasterWithMessage()
  const {globalState,handleGlobalState} = useContext<any>(globalContext);

  const [invoiceDetails] = useLazyQuery(INVOICE_DETAILS_DOWNLOAD,{
    fetchPolicy : "no-cache",
    onCompleted: (invoicedata) =>{
      setShowInvoiceDetails(invoicedata?.ticket_placement_by_pk)
    },
    onError : () =>{
     error("Something went wrong!")
    }
  })

  useEffect(()=>{
    if(openPopup){
    invoiceDetails({
      variables :{
        ticketPlacementId : row?.tp_id
      }
    })
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[openPopup])

  const handleDownloadAsPDF = async () => {
    handleCloseDialog()
  };
  
const [autoPayoutTicket] = useMutation(AUTO_PAYOUT, {
  onCompleted: (data) => {
    const tempState = { ...globalState };
    tempState.loadingForAutoPayout.AutoPayoutLoader = false;
    handleGlobalState(tempState);
    if (data.transferAmountToUsersByTicket.message === "Payment Success") {
      setCurrentPage(1);
      setColumnTypes("e_date");
      setSortType("desc");
      success("Payment completed successfully");
    } else if (
      data.transferAmountToUsersByTicket.message.includes(
        "insufficient available"
      )
    ) {
      error("You have insufficient available funds in your Stripe account");
    } else {
      error("Payment Failed");
    }
    const tempdata = { ...globalState };
    tempdata.payoutTicket.payment = true;
    handleGlobalState(tempdata);
  },
  onError: (er) => {
    const tempState = { ...globalState };
    tempState.loadingForAutoPayout.AutoPayoutLoader = false;
    handleGlobalState(tempState);
    if(er.message.includes("insufficient available funds")){
      error("You have insufficient available funds in your Stripe account");
    }else if(er.message.includes("User's stripe account status is Inactive")){
      error(er.message)
    }else{
    error(er.message);
    }
    const tempdata = { ...globalState };
    tempdata.payoutTicket.payment = true;
    handleGlobalState(tempdata);
  }, 
});

const handleclickAutoPayout = (row: soldTicketsRowType) => {
  const tempState = { ...globalState };
  tempState.loadingForAutoPayout.AutoPayoutLoader = true;
  handleGlobalState(tempState);
  autoPayoutTicket({
    variables: {
      ticketPlacementId: row?.tp_id,
    },
  });
};

  return (
    <div>
        <div className={styles.markAsSold}>
          <div className={styles.downloaddiv} ref={contentRef}>
          <div className={styles.title}>
            <div className={styles.markAsSoldTitle}>
              {row?.tp_payment_status === "Success" ? `Invoice` : row?.tp_payment_status === "Inprogress" ? `Payout - Inprogress`: `Payout`}
            </div>
            <div className={styles.closeicon}>
              <img
                src={CloseIcon}
                alt="closeicon"
                onClick={handleCloseDialog}
              />
            </div>
          </div>
          <div className={styles.eventDetailsAndLogitixSold}>
            <div className={styles.eventDetails}>
              <div className={styles.eventDetails1}>Ticket Details</div>
              <div className={styles.eventDetails2}>
                <div className={styles.event}>
                  <b className={styles.date}>Event</b>
                  <b className={styles.rocketsVsMemphis}>{showInvoiceDetails?.ticket?.event?.eventName ? showInvoiceDetails?.ticket?.event?.eventName : '-'}</b>
                </div>
                <div className={styles.event}>
                  <b className={styles.date}>Date</b>
                  <b className={styles.rocketsVsMemphis}>
                    {checking(showInvoiceDetails?.ticket?.event?.eventDate ? showInvoiceDetails?.ticket?.event?.eventDate : '').date} /{" "}
                    {checking(showInvoiceDetails?.ticket?.event?.eventDate ? showInvoiceDetails?.ticket?.event?.eventDate : '').time}
                  </b>
                </div>
                <div className={styles.event}>
                  <b className={styles.date}>Venue</b>
                  <b className={styles.rocketsVsMemphis}>
                  {splitLocation(showInvoiceDetails?.ticket?.event?.eventAddress ? showInvoiceDetails?.ticket?.event?.eventAddress : '').firstWord}
                  {splitLocation(showInvoiceDetails?.ticket?.event?.eventAddress ? showInvoiceDetails?.ticket?.event?.eventAddress : '').remainingWords}
                  </b>
                </div>
                <div className={styles.event}>
                  <b className={styles.date}>Ticket Placement</b>
                  <b className={styles.secA}>
                    Sec : {showInvoiceDetails?.section ? showInvoiceDetails?.section : '-'} / Row : {showInvoiceDetails?.row ? showInvoiceDetails?.row : '-'} / Seat : {showInvoiceDetails?.seatNo ? showInvoiceDetails?.seatNo:"-"}
                  </b>
                </div>
                <div className={styles.event}>
                  <b className={styles.date}>Number Of Tickets</b>
                  <b className={styles.secA}>1</b>
                </div>
                <div className={styles.event}>
                <b className={styles.date}>Sold Price</b>
                <b className={styles.secA}>
                 ${row?.tp_list_price ? formatNumberWithCommas(row?.tp_list_price) : '-'}
                </b>
              </div>
              </div>
            </div>
            <div className={styles.logitixSoldPrice}>
              <div className={styles.eventDetails1}>Order Summary</div>
              <div className={styles.bg}>
                <div className={styles.eventDetails}>
                  {row?.tp_payment_status === "Success" && (
                    <>
                      <div className={styles.soldPrice}>
                        <div className={styles.transactionId}>
                          <b className={styles.date}>Transaction ID</b>
                        </div>
                        <div className={styles.transactionId}>
                          <b className={styles.invoiceamount}>{showInvoiceDetails?.payment_transaction[0]?.transactionId ? showInvoiceDetails?.payment_transaction[0]?.transactionId : '-'}</b>
                        </div>
                      </div>
                      <div className={styles.soldPrice}>
                        <div className={styles.transactionId}>
                          <b className={styles.date}>Date & Time</b>
                        </div>
                        <div className={styles.transactionId}>
                          <b className={styles.invoiceamount}>
                            {
                              showInvoiceDetails?.payment_transaction?.[0]?.paymentUpdated ? 
                              <>
                              {checking(showInvoiceDetails?.payment_transaction?.[0]?.paymentUpdated ? showInvoiceDetails?.payment_transaction?.[0]?.paymentUpdated: "-").date} /{" "}
                              {checking(showInvoiceDetails?.payment_transaction?.[0]?.paymentUpdated ? showInvoiceDetails?.payment_transaction?.[0]?.paymentUpdated: "-").time}            
                              </>  : "-"
                            }
                          </b>
                        </div>
                      </div>
                    </>
                  )}
                  <div className={styles.soldPrice}>
                    <div className={styles.transactionId}>
                      <b className={styles.date}>Received Amount From Logitix</b>
                    </div>
                    <div className={styles.transactionId}>
                      <b className={styles.invoiceamount}>${showInvoiceDetails?.tp_logitix_amount ? formatNumberWithCommas(showInvoiceDetails?.tp_logitix_amount) : '0'}</b>
                    </div>
                  </div>
                  <div className={styles.soldPrice}>
                    <div className={styles.transactionId}>
                      <b className={styles.date}>QuickAsyst Fee</b>
                    </div>
                    <div className={styles.transactionId}>
                      <b className={styles.invoiceamount}>-${showInvoiceDetails?.tp_quick_cut_amount ? parseFloat(showInvoiceDetails?.tp_quick_cut_amount.toFixed(2)) : '0'}</b>
                    </div>
                  </div>
                  <div className={styles.soldPrice}>
                    <div className={styles.transactionId}>
                      <b className={styles.date}>Tax and Charges</b>
                    </div>
                    <div className={styles.transactionId}>
                      <b className={styles.invoiceamount}>-$0</b>
                    </div>
                  </div>
                  <div className={styles.soldPrice}></div>
                  <div className={styles.line}></div>
                  <div className={styles.settlementAmount}>
                    <b className={styles.amountUser}>
                      Amount to be settled for {row?.tp_is_support_vanderbilt_nil_fund ? 'direct affiliates' : 'users'}
                    </b>
                    <b className={styles.finalAmount}>${showInvoiceDetails?.tp_sold_amount ? formatNumberWithCommas(showInvoiceDetails?.tp_sold_amount) : '0'}</b>
                  </div>
                </div>
              </div>
            </div>
          </div>
          </div>
          {row?.tp_payment_status === "Success" && !row?.tp_is_support_vanderbilt_nil_fund && (
          <a href={`${window.location.origin}/${showInvoiceDetails?.payment_transaction[0]?.stripe_transfers?.st_invoice}`} download target="_blank" rel="noopener noreferrer" className={styles.anchor}> 
            <div className={styles.cta}>
              <div className={styles.buttons1} onClick={handleDownloadAsPDF}>
              <Button
                  classes={{ root: styles.separateStyle }}
                  disableRipple
                  fullWidth
                >
                  Download
                </Button>
              </div>
            </div>
            </a>
          )}
          {(((row?.tp_payment_status === null && row?.tp_status==="Sold") || row?.tp_payment_status === "Failed") && !row?.tp_is_support_vanderbilt_nil_fund) && (
            <div className={styles.cta}>
              <div className={styles.buttons1} onClick={(e)=> handleclickAutoPayout(row)}>
                <Button
                  classes={{ root: styles.separateStyle }}
                  disableRipple
                  fullWidth
                >
                  Mark As Settled
                </Button>
              </div>
            </div>
          )} 
        </div>
    </div>
  );
};

export default InvoicePopup;
